import { render, staticRenderFns } from "./vericiler.vue?vue&type=template&id=f10073a4&"
import script from "./vericiler.vue?vue&type=script&lang=js&"
export * from "./vericiler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports